import { render, staticRenderFns } from "./ChatVoicePlayer.vue?vue&type=template&id=869d84b8"
import script from "./ChatVoicePlayer.vue?vue&type=script&lang=js"
export * from "./ChatVoicePlayer.vue?vue&type=script&lang=js"
import style0 from "./ChatVoicePlayer.vue?vue&type=style&index=0&id=869d84b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports